import { mapState, mapActions } from 'vuex';

import { useDataLoading, usePagination } from '@mixins/factories';

import OperatorSynchronizer from '../../_components/operatorSynchronizer';
import OperatorDependenciesEditor from '../../_components/OperatorDependenciesEditor';

import { getLocationNameBySuffix } from '../../_utils';

const dataLoadingOptions = {
  getterName: 'getOperators',
  contentName: 'operators',
  parameterize: true,
  searchable: false,
};
const paginationOptions = { contentName: 'operators' };

const operatorsHeaders = Object.freeze([
  { text: 'Name', value: 'name', width: '25%' },
  { text: 'Email', value: 'email', width: '30%' },
  { text: 'Barcode', value: 'barcode' },
  { text: 'Machines', value: 'machines' },
  { text: 'Locations', value: 'locations' },
  { text: '', value: 'actions', width: '5%' },
]);

export default {
  name: 'Operators',
  mixins: [
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
  ],
  components: {
    OperatorSynchronizer,
    OperatorDependenciesEditor,
  },
  data() {
    return {
      operatorsHeaders,
    };
  },
  computed: {
    ...mapState('operators', ['operators']),
    ...mapState('locations', ['locations']),
  },
  watch: {
    suffix() {
      this.$_refreshData();
    },
  },
  created() {
    this.getMachines();
  },
  methods: {
    ...mapActions('operators', ['getOperators']),
    ...mapActions('machines', ['getMachines']),

    getLocationNameBySuffix(suffix) {
      return getLocationNameBySuffix(suffix, this.locations);
    },
  },
};
